import round from 'lodash-es/round'
import { DataPoint } from '@/jsonapi/CommonTypes'
import { VuetifyThemeItem } from 'vuetify/types/services/theme'
import { buildSummaryReportLineChartOption } from '@/components/patient-stats/graphs/summary-reports/chart-options/summary-line-chart/build-summary-report-line-chart-options'
import { buildSummaryReportPulseOxyLineChartOption } from '@/components/patient-stats/graphs/summary-reports/chart-options/summary-line-chart/build-summary-report-pulse-oxy-line-chart-options'

export function buildPerfusionIndexChartOption(options: {
  perfusionIndexes: DataPoint[]
  timezone: string
  startTimestamp: number
  endTimestamp: number
  colors: VuetifyThemeItem | any // FIXME
}): any {
  let { perfusionIndexes, timezone, startTimestamp, endTimestamp, colors } = options
  const dpMaxY = Math.max(...perfusionIndexes.map(dp => dp.value))
  const dpMinY = Math.min(...perfusionIndexes.map(dp => dp.value))
  const diffBetweenMinAndMaxDp = Math.max(10, dpMaxY - dpMinY)
  const maxY = round(dpMaxY + diffBetweenMinAndMaxDp * 0.125, 1)
  const minY = Math.max(0, round(dpMinY - diffBetweenMinAndMaxDp * 0.125, 1))

  return buildSummaryReportPulseOxyLineChartOption({
    startTimestamp,
    endTimestamp,
    timezone,
    actualDataPoints: perfusionIndexes,
    rollingAvgDataPoints: [],
    lineColor: colors.primary,
    unitLabel: '%',
    maxY,
    minY,
    yAxisOption: {
      axisLabel: {
        show: true,
        color: colors.primary,
        formatter: params => String(params),
      },
      axisLine: { show: false },
      splitLine: {
        show: true,
        showMaxLabel: false,
        lineStyle: {
          color: '#0f45cd',
          opacity: 0.2,
          width: 0.5,
        },
      },
      minInterval: 0.1,
      splitNumber: 4,
    },
  })
}
